import { Heading, Center } from "@chakra-ui/react";

function EndScreen() {
  return (
    <Center width="100vw" height="100vh" bg="yellow.200">
      <Heading size="2xl">You finished the game!</Heading>
    </Center>
  );
}

export default EndScreen;